import React from "react";
import { SignInMethod, lastSignInMethod } from "../../utils/lastSignInMethod";

// "Last used", pinned to the top-right corner of a login option (the
// parent must be `position: relative`).
export function LastUsedBadge({ method }: { method: SignInMethod }) {
    if (lastSignInMethod() !== method) return null;
    return (
        <span
            data-testid={`last-used-${method}`}
            className="absolute right-3 -top-2 rounded-full px-2 leading-4 pointer-events-none"
            style={{
                fontSize: "10px",
                fontWeight: 600,
                background: "#fff",
                color: "#1f1f1f",
                border: "1px solid #dadce0"
            }}
        >
            Last used
        </span>
    );
}
